import script from "./OrganizerPublicView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizerPublicView.vue?vue&type=script&setup=true&lang=js"

import "./OrganizerPublicView.vue?vue&type=style&index=0&id=8158d202&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8158d202"]])

export default __exports__